// @flow
import asyncComponent from './components/core/asyncComponent';
import RightsUtil from './util/rights-util';

const Pilot = asyncComponent(() => import(
  /* webpackChunkName: 'pilot' */ './containers/Pilot.js'
));

const Forbidden = asyncComponent(() => import(
  /* webpackChunkName: 'forbidden' */ './containers/Forbidden.js'
));

const Terms = asyncComponent(() => import(
  /* webpackChunkName: 'terms' */ './containers/Terms.js'
));

const Home = asyncComponent(() => import(
  /* webpackChunkName: 'home' */ './containers/Home.js'
));

const OnBoarding = asyncComponent(() => import(
  /* webpackChunkName: 'onboarding' */ './containers/OnBoarding.js'
));

const Profile = asyncComponent(() => import(
  /* webpackChunkName: 'profile' */ './containers/Profile.js'
));

const Pathway = asyncComponent(() => import(
  /* webpackChunkName: 'pathway' */ './containers/Pathway.js'
));

const PathwayPlaybookItemContainer = asyncComponent(() => import(
  /* webpackChunkName: 'pathway-playbookItem' */ './containers/PathwayPlaybookItemContainer.js'
));

const PlaybookItemContainer = asyncComponent(() => import(
  /* webpackChunkName: 'playbookItem' */ './containers/PlaybookItemContainer.js'
));

const GrowActivation = asyncComponent(() => import(
  /* webpackChunkName: 'grow-activation' */ './containers/GrowActivation.js'
));

const Admin = asyncComponent(() => import(
  /* webpackChunkName: 'admin' */ './containers/admin/Admin.js'
));

const AdminRights = asyncComponent(() => import(
  /* webpackChunkName: 'admin-rights' */ './containers/admin/AdminRights.js'
));

const AdminLang = asyncComponent(() => import(
  /* webpackChunkName: 'admin-lang' */ './containers/admin/AdminLang.js'
));

const AdminLangUpdate = asyncComponent(() => import(
  /* webpackChunkName: 'admin-lang-update' */ './containers/admin/AdminLangUpdate.js'
));

const AdminLangAdd = asyncComponent(() => import(
  /* webpackChunkName: 'admin-lang-add' */ './containers/admin/AdminLangAdd.js'
));

export default [
  {
    path: 'pilot',
    component: Pilot
  },
  {
    path: 'forbidden',
    component: Forbidden
  },
  {
    path: 'terms',
    component: Terms
  },
  {
    path: 'onboarding',
    component: OnBoarding
  },
  {
    path: 'profile',
    component: Profile
  },
  {
    path: 'pathway/:pathwayPath/:topicKey/playbook/:playbookItemPath',
    component: PathwayPlaybookItemContainer
  },
  {
    path: 'pathway/:path',
    component: Pathway
  },
  {
    path: 'playbook/:pathwayPath/:playbookItemPath',
    component: PlaybookItemContainer
  },
  {
    path: 'activation',
    component: GrowActivation
  },
  {
    path: 'admin/rights',
    component: AdminRights,
    canAccess: RightsUtil.canAccessRightsAdmin
  },
  {
    path: 'admin/lang/new',
    component: AdminLangAdd,
    canAccess: RightsUtil.canAccessLangAdmin
  },
  {
    path: 'admin/lang/:code',
    component: AdminLangUpdate,
    canAccess: RightsUtil.canAccessLangAdmin
  },
  {
    path: 'admin/lang',
    component: AdminLang,
    canAccess: RightsUtil.canAccessLangAdmin
  },
  {
    path: 'admin',
    component: Admin,
    canAccess: RightsUtil.canAccessAdmin
  },
  {
    path: '',
    component: Home
  }
];



// WEBPACK FOOTER //
// ./src/authenticatedRoutes.js